import Phaser from "phaser";

// import myRaidPng from "@/game/assets/fonts/bitmap/myRaidReg.png";
// import myRaidXml from "@/game/assets/fonts/bitmap/myRaidReg.xml";
// import myRaidGoldenPng from "@/game/assets/fonts/bitmap/myRaidGolden.png";
// import myRaidGoldenXml from "@/game/assets/fonts/bitmap/myRaidGolden.xml";
import digitalPng from "@/game/assets/fonts/bitmap/digital-7.png";
import digitalXml from "@/game/assets/fonts/bitmap/digital-7.xml";
// import myRaidBoldPng from "@/game/assets/fonts/bitmap/myRaidBold.png";
// import myRaidBoldXml from "@/game/assets/fonts/bitmap/myRaidBold.xml";
// import HelveticaNeuePng from "@/game/assets/fonts/bitmap/HelveticaNeue.png";
// import HelveticaNeueXml from "@/game/assets/fonts/bitmap/HelveticaNeue.xml";
// import HelveticaNeueTealPng from "@/game/assets/fonts/bitmap/HelveticaNeueMedTeal.png";
// import HelveticaNeueTealXml from "@/game/assets/fonts/bitmap/HelveticaNeueMedTeal.xml";
// import HelveticaNeueGrayPng from "@/game/assets/fonts/bitmap/HelveticaNeueMedGray.png";
// import HelveticaNeueGrayXml from "@/game/assets/fonts/bitmap/HelveticaNeueMedGray.xml";
import localScaleManager from "@/game/src/helpers/LocalScaleManager";

class PreloadScene extends Phaser.Scene {
  constructor() {
    super({
      key: "PreloadScene",
    });
  }
  preload() {
    this.load.atlas(
      "megaSet",
      require("../../assets/atlas/v10.7.png"),
      require("../../assets/atlas/v10.7_atlas.json")
    );
    this.load.atlas(
      "avatars",
      require("../../assets/atlas/avatars5.png"),
      require("../../assets/atlas/avatars5_atlas.json")
    );
    // this.load.image("test", require("../../assets/images/test.png"));

    this.load.image("bg", require("../../assets/images/bg.png"));
    this.load.image("table", require("../../assets/images/table.png"));
    /*** audios */
    this.load.audio("allin", require("../../assets/audios/allin.mp3"));
    this.load.audio("bet", require("../../assets/audios/bet.mp3"));
    this.load.audio("call", require("../../assets/audios/call.wav"));
    this.load.audio("check", require("../../assets/audios/check.mp3"));
    this.load.audio("deal", require("../../assets/audios/deal.wav"));
    this.load.audio("flop", require("../../assets/audios/flop.wav"));
    this.load.audio("fold", require("../../assets/audios/fold.mp3"));
    this.load.audio("raise", require("../../assets/audios/raise.mp3"));
    this.load.audio(
      "show-win-amount",
      require("../../assets/audios/show-win-amount.mp3")
    );
    this.load.audio(
      "stack-chips",
      require("../../assets/audios/stack-chips.mp3")
    );
    this.load.audio(
      "time-action-warning",
      require("../../assets/audios/time-action-warning.mp3")
    );
    this.load.audio("timer", require("../../assets/audios/timer_01.wav"));
    this.load.audio("win-chips", require("../../assets/audios/win-chips.mp3"));
    this.load.audio(
      "turn-river",
      require("../../assets/audios/turn-river.mp3")
    );

    /*** sprite sheets */
    this.load.spritesheet(
      "classic-deck",
      require("../../assets/spritesheet/cards.png"),
      {
        frameWidth: 100,
        frameHeight: 133,
      }
    );
    this.load.spritesheet(
      "four-color-deck",
      require("../../assets/spritesheet/four-color-deck.png"),
      {
        frameWidth: 100,
        frameHeight: 133,
      }
    );
    this.load.spritesheet(
      "classic-deck-kicker",
      require("../../assets/spritesheet/cards-kicker.png"),
      {
        frameWidth: 100,
        frameHeight: 133,
      }
    );
    this.load.spritesheet(
      "four-color-deck-kicker",
      require("../../assets/spritesheet/four-color-deck-kicker.png"),
      {
        frameWidth: 100,
        frameHeight: 133,
      }
    );

    /*** bitmap fonts */
    // this.load.bitmapFont("myRaid", myRaidPng, myRaidXml);
    // this.load.bitmapFont("myRaidGolden", myRaidGoldenPng, myRaidGoldenXml);
    this.load.bitmapFont("digital", digitalPng, digitalXml);
    // this.load.bitmapFont("myRaidBold", myRaidBoldPng, myRaidBoldXml);

    // if (window.devicePixelRatio <= 1) {
    this.load.bitmapFont(
      "HelveticaNeue",
      require("../../assets/fonts/bitmap/HelveticaNeueMedium.png"),
      require("../../assets/fonts/bitmap/HelveticaNeueMedium.xml")
    );
    this.load.bitmapFont(
      "HelveticaNeueTeal",
      require("../../assets/fonts/bitmap/HelveticaNeueMediumTeal.png"),
      require("../../assets/fonts/bitmap/HelveticaNeueMediumTeal.xml")
    );
    this.load.bitmapFont(
      "HelveticaNeueGray",
      require("../../assets/fonts/bitmap/HelveticaNeueMediumGray.png"),
      require("../../assets/fonts/bitmap/HelveticaNeueMediumGray.xml")
    );
    // } else {
    //   this.load.bitmapFont(
    //     "HelveticaNeue",
    //     require("../../assets/fonts/bitmap/HelveticaNeueLight.png"),
    //     require("../../assets/fonts/bitmap/HelveticaNeueLight.xml")
    //   );
    //   this.load.bitmapFont(
    //     "HelveticaNeueTeal",
    //     require("../../assets/fonts/bitmap/HelveticaNeueLightTeal.png"),
    //     require("../../assets/fonts/bitmap/HelveticaNeueLightTeal.xml")
    //   );
    //   this.load.bitmapFont(
    //     "HelveticaNeueGray",
    //     require("../../assets/fonts/bitmap/HelveticaNeueLightGray.png"),
    //     require("../../assets/fonts/bitmap/HelveticaNeueLightGray.xml")
    //   );
    // }
    this.load.bitmapFont(
      "disconnected",
      require("../../assets/fonts/bitmap/disconnected-pink.png"),
      require("../../assets/fonts/bitmap/disconnected-pink.xml")
    );

    this.startLoading();

    // this.load.plugin('rexinputtextplugin', 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexinputtextplugin.min.js', true);
    // this.load.plugin('rexUI', 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexuiplugin.min.js', true);
  }
  startLoading1() {
    this.add.rectangle(
      0,
      0,
      this.cameras.main.width * 2,
      this.cameras.main.height * 2,
      0x253043
    );
    let loadingImg = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "loading"
    );
    let loadingImgScale = localScaleManager.scaleSprite(
      loadingImg,
      this.cameras.main.width / 3,
      this.cameras.main.height / 5,
      0,
      1,
      true
    );
    localScaleManager.scaleSpriteTo(loadingImg, loadingImgScale);

    let loadingTween = this.tweens.add({
      targets: loadingImg,
      // x: loadingImg.x + 1,
      ease: "Quad.easeIn",
      duration: 650,
      scaleX: 0,
      flipX: true,
      yoyo: true,
      loop: -1,
    });
    let width = this.cameras.main.width;
    let height = this.cameras.main.height;
    let progressBox = this.add.graphics();
    let progressBar = this.add.graphics();
    // progressBox.fillStyle(0x000000, 0.8);
    progressBox.fillStyle(0x000000, 0.8);
    progressBox.fillRoundedRect(
      (width - width / 1.1) / 2,
      height / 1.1,
      width / 1.1,
      50,
      20
    );

    let loadingText = this.make.text({
      x: width / 2,
      y: height / 1.1 - 50,
      text: "Loading...",
      style: {
        font: "20px monospace",
        fill: "#ffffff",
      },
    });
    loadingText.setOrigin(0.5, 0.5);
    let percentText = this.make.text({
      x: width / 2,
      y: height / 1.1 + 25,
      text: "0%",
      style: {
        font: "18px monospace",
        fill: "#ffffff",
      },
    });
    percentText.setOrigin(0.5, 0.5);
    this.load.on("progress", function (value) {
      percentText.setText(parseInt(value * 100) + "%");
      progressBar.clear();
      progressBar.fillStyle(0x006770, 1);
      progressBar.fillRoundedRect(
        (width - width / 1.11) / 2,
        height / 1.1 + 10,
        (width / 1.11) * value,
        30,
        15
      );
    });

    this.load.on("fileprogress", function (file) {});

    this.load.on("complete", () => {
      // progressBar.destroy();
      // progressBox.destroy();
      // loadingText.destroy();
      // percentText.destroy();
      loadingText.setText("Connecting...");
      this.scene.launch("GameScene");
      this.cameras.main.backgroundColor = "#0x253043";
      this.scene.bringToTop();
    });
  }
  startLoading() {
    this.add.rectangle(
      0,
      0,
      this.cameras.main.width * 2,
      this.cameras.main.height * 2,
      0x212937
    );

    this.loadingPart5 = this.add.image(0, 0, "loading", "loading-5");
    this.loadingPart6 = this.add.image(0, 0, "loading", "loading-6");
    this.loadingPart1 = this.add.image(0, 0, "loading", "loading-1");
    this.loadingPart2 = this.add.image(0, 0, "loading", "loading-2");
    this.loadingPart3 = this.add.image(0, 0, "loading", "loading-3");
    this.loadingPart4 = this.add.image(0, 0, "loading", "loading-4");

    let loadingArray = [
      this.loadingPart6,
      this.loadingPart5,
      this.loadingPart4,
      this.loadingPart3,
      this.loadingPart2,
      this.loadingPart1,
    ];
    this.progressBarBg = this.add.image(
      0,
      0,
      "loading",
      "loading-progress-empty"
    );
    this.progressBar = this.add.image(0, 0, "loading", "loading-progress-full");
    this.shape = this.make.graphics();
    this.shape.fillStyle(0xffffff);
    this.positionControls();

    const chain = this.tweens.chain({
      targets: loadingArray,
      tweens: [
        {
          y: this.cameras.main.height / 2,
          duration: 1000,
          ease: "Sine.easeInOut",
          delay: this.tweens.stagger(50),
        },
        {
          y: this.cameras.main.height / 2,
          duration: 1000,
          ease: "Sine.easeInOut",
        },
        {
          y: -this.loadingPart1.displayHeight,
          duration: 1000,
          ease: "Sine.easeInOut",
          delay: this.tweens.stagger(50),
          onComplete: () => {
            Phaser.Actions.SetY(
              loadingArray,
              this.cameras.main.height + this.loadingPart1.displayHeight
            );
          },
        },
      ],
      loop: -1,
      loopDelay: 2000,
      // onComplete: () => this.openChest(chest, key),
    });

    // var timeline = this.tweens.createTimeline();
    // timeline.add({
    //   targets: loadingArray,
    //   y: this.cameras.main.height / 2,
    //   // yoyo: true,
    //   duration: 1000,
    //   ease: "Sine.easeInOut",
    //   // repeat: -1,
    //   delay: this.tweens.stagger(50),
    // });
    // timeline.add({
    //   targets: loadingArray,
    //   y: this.cameras.main.height / 2,
    //   // yoyo: true,
    //   duration: 1000,
    //   ease: "Sine.easeInOut",
    //   // repeat: -1,
    // });
    // timeline.add({
    //   targets: loadingArray,
    //   y: -this.loadingPart1.displayHeight,
    //   // yoyo: true,
    //   duration: 1000,
    //   ease: "Sine.easeInOut",
    //   // repeat: -1,
    //   delay: this.tweens.stagger(50),
    //   onComplete: () => {
    //     Phaser.Actions.SetY(
    //       loadingArray,
    //       this.cameras.main.height + this.loadingPart1.displayHeight
    //     );
    //   },
    // });
    // timeline.loop = -1;
    // timeline.loopDelay = 2000;
    // // timeline.yoyo = true;
    // timeline.play();

    // let width = this.cameras.main.width;
    // let height = this.cameras.main.height;
    // let progressBox = this.add.graphics();
    // let progressBar = this.add.graphics();
    // progressBox.fillStyle(0x000000, 0.8);
    // progressBox.fillStyle(0x000000, .8);
    // progressBox.fillRoundedRect((width - width / 1.1 ) / 2, height / 1.1, width / 1.1, 50, 20);
    let percentText = this.make.text({
      x: this.progressBar.x,
      y: this.progressBar.y - this.progressBar.displayHeight * 0.1,
      text: "0%",
      style: {
        font: "18px monospace",
        fill: "#0e9877",
      },
    });
    percentText.setOrigin(0.5, 0.5);
    this.load.on("progress", (value) => {
      // let yLevel = 0;
      // if (pointer.y > this.maxHeight && pointer.y < this.minHeight) {
      //   yLevel = pointer.y;
      // } else if (pointer.y <= this.maxHeight) {
      //   yLevel = this.maxHeight;
      // } else if (pointer.y >= this.minHeight) {
      //   yLevel = this.minHeight;
      // }
      // this.updateRaiseAmount(yLevel);

      this.shape.clear();
      // this.chip.setY(yLevel);
      this.shape.fillRect(
        this.progressBar.x - this.progressBar.displayWidth / 2,
        this.progressBar.y - this.progressBar.displayHeight / 2,
        this.progressBar.displayWidth * value,
        this.progressBar.displayHeight
      );
      this.shape.fillPath();
      percentText.setText(parseInt(value * 100) + "%");
      // progressBar.fillStyle(0x006770, 1);
      // progressBar.fillRoundedRect((width - width / 1.11) / 2, height / 1.1 + 10, width / 1.11 * value, 30, 15);
    });

    // this.load.on('fileprogress', function (file) {
    // });

    this.load.on("complete", () => {
      // progressBar.destroy();
      // progressBox.destroy();
      // loadingText.destroy();
      // timeline.destroy();
      percentText.setText("Connecting...");
      this.scene.launch("GameScene");
      this.scene.bringToTop();
    });
    this.events.on("destroy", () => {
      this.children.getChildren().forEach((child) => child.destroy());
    });
  }
  positionControls() {
    const height = this.cameras.main.height;
    const width = this.cameras.main.width;
    const centerX = width / 2;
    const centerY = height / 2;

    const scale = Math.min(width / 5, height / 6);

    let loadingPartScale = localScaleManager.scaleSprite(
      this.loadingPart1,
      scale,
      scale,
      0,
      1,
      true
    );
    localScaleManager.scaleSpriteTo(this.loadingPart2, loadingPartScale);
    localScaleManager.scaleSpriteTo(this.loadingPart3, loadingPartScale);
    localScaleManager.scaleSpriteTo(this.loadingPart4, loadingPartScale);
    localScaleManager.scaleSpriteTo(this.loadingPart5, loadingPartScale);
    localScaleManager.scaleSpriteTo(this.loadingPart6, loadingPartScale);

    const distanceBetween3s = this.loadingPart1.displayWidth / 4;

    this.loadingPart1.setPosition(
      centerX - (distanceBetween3s + this.loadingPart1.displayWidth) / 2,
      height + this.loadingPart1.displayHeight
    );
    this.loadingPart2.setPosition(
      centerX + (distanceBetween3s + this.loadingPart2.displayWidth) / 2,
      height + this.loadingPart1.displayHeight
    );
    this.loadingPart3.setPosition(
      centerX - (distanceBetween3s + this.loadingPart1.displayWidth) / 2,
      height + this.loadingPart1.displayHeight
    );
    this.loadingPart4.setPosition(
      centerX + (distanceBetween3s + this.loadingPart2.displayWidth) / 2,
      height + this.loadingPart1.displayHeight
    );
    this.loadingPart5.setPosition(
      centerX - (distanceBetween3s + this.loadingPart1.displayWidth) / 2,
      height + this.loadingPart1.displayHeight
    );
    this.loadingPart6.setPosition(
      centerX + (distanceBetween3s + this.loadingPart2.displayWidth) / 2,
      height + this.loadingPart1.displayHeight
    );

    localScaleManager.scaleSpriteTo(this.progressBarBg, loadingPartScale * 1.5);
    localScaleManager.scaleSpriteTo(this.progressBar, loadingPartScale * 1.5);
    this.progressBarBg.setPosition(
      centerX,
      centerY + this.loadingPart1.displayHeight
    );
    this.progressBar.setPosition(this.progressBarBg.x, this.progressBarBg.y);
    this.shape.fillRect(
      this.progressBar.x - this.progressBar.displayWidth / 2,
      this.progressBar.y - this.progressBar.displayHeight / 2,
      0,
      this.progressBar.displayHeight
    );

    this.shape.fillPath();

    this.mask = this.shape.createGeometryMask();

    this.progressBar.setMask(this.mask);
  }
}
export default PreloadScene;
